export default async function toBase64(file: File) {
  
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();

    if(reader) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        let encoded = reader.result?.toString().replace(/^data:(.*,)?/, "");
        if (encoded && encoded.length % 4 > 0) {
          encoded += "=".repeat(4 - (encoded.length % 4));
        }

        resolve(encoded);
      };

      reader.onerror = error => reject(error);
    }
  });
}